const AdminService = {
    isAdminAllowed,
};

function isAdminAllowed() {
    return import.meta.env.REACT_APP_FEATURE_ADMIN === 'true';
}

export default AdminService;
